if ($(".enroledchildform").length > 0) {


    function IsSchoolAge(yes) {
        if (yes == true) {
            $(".SchoolAgeCommentDivs").removeAttr("hidden");
            $(".notschool").attr("hidden", "hidden");
            $(".leftDiv").addClass("col-4 col-md-4")
            $(".leftDiv").removeClass("col-2 col-md-2")
            $(".rightDiv").addClass("col-8 col-md-8")
            $(".rightDiv").removeClass("col-10 col-md-10")

            if (jsIsDesignated) {
                $(".nobenefitsMsg").removeClass("d-none")

                if (jsHasParentSubsidy) {
                    $(".nobenefitsPS").removeClass("d-none")
                    $(".nobenefits").addClass("d-none")
                }
                else {
                    $(".nobenefits").removeClass("d-none")
                    $(".nobenefitsPS").addClass("d-none")
                }
            }



            //Determine is we should display the daily fee type div control
            SetDailyFeeTypeDiv();
        }
        else {
            $(".SchoolAgeCommentDivs").attr("hidden", "hidden");
            $(".notschool").removeAttr("hidden");
            $(".leftDiv").addClass("col-2 col-md-2")
            $(".leftDiv").removeClass("col-4 col-md-4")
            $(".rightDiv").addClass("col-10 col-md-10")
            $(".rightDiv").removeClass("col-8 col-md-8")

            $(".nobenefitsMsg").addClass("d-none")
            $(".nobenefits").addClass("d-none")
            $(".nobenefitsPS").addClass("d-none")

            //Determine if we should show the checkbox or line for frequency
            HandleWeeklyFrequencyOptions();

            //Determine is we should display the daily fee type div control
            SetDailyFeeTypeDiv();

            //Determine if the fee url should be displayed
            var license = $('select#LicenseNumber').val();

            if (license != '') {
                $('.btnfeediv').removeAttr("hidden");
            }
            else {
                $('.btnfeediv').attr("hidden", "hidden");
            }
        }
    }

    function HandleWeeklyFrequencyOptions() {
        HandleFrequencyOptions('monday');
        HandleFrequencyOptions('tuesday');
        HandleFrequencyOptions('wednesday');
        HandleFrequencyOptions('thursday');
        HandleFrequencyOptions('friday');
    }





    $(document).ready(function () {
        $('[data-toggle="tooltip"]').tooltip();

        //Add this class to the daily fee type control
        //so we can nide if when the page first loads
        //$("#DailyFeeTypeCd").each(function () {
        //    $(this).addClass("togglecontrol");
        //});

        ShowHideInactiveRelatedGroups();

        var StatusValue = $('select#StatusEnrollmentCd').val();
        HandleInactiveStatus(true);

        if ($("#EffectiveDate").val() === "0001-01-01") {
            $("#EffectiveDate").val("");
        }

    //Hide the edit button on edit for an inactive enrolment
        if (StatusEnrollmentCd == inactiveStatus || $("#StatusEnrollmentCd option:selected").val() == inactiveStatus) {

            if (!isAdmin) { // allow admins to edit anyway
                $(".editcontrol").attr("hidden", "hidden");
            }
        
            $('select#LicenseNumber').attr("disabled", "disabled");
            $('.rad').attr("disabled", "disabled");
            $('.tick').attr("disabled", "disabled");
            $('#chkSelectAll').attr("disabled", "disabled");
            $('#ExistingRegistration').attr("disabled", "disabled");
            $(".inactivewarning").removeClass('d-none');
        }

        SetEditOnlyMode();
        if (pageReload) {           
            //Enable/disable the effective date
            if (cannotModifyEffectiveDate) {
                $(".toggleeffectivedate").attr("disabled", "disabled");
            } else {
                $(".toggleeffectivedate").removeAttr("disabled");
            }

            //if (EffectiveDate <= now) {
            //    $(".toggleeffectivedate").attr("disabled", "disabled");
            //}
            //else {
            //    $(".toggleeffectivedate").removeAttr("disabled");
            //}


            if ($("#StatusEnrollmentCd option:selected").val() == inactiveStatus) {
                $(".inactivediv").attr("hidden", "hidden");
                $(".toggleeffectivedate").removeAttr("disabled");
            }

        } else {
            //SetReadOnlyMode();
            //if (EffectiveDate <= now) {
            //    $(".toggleeffectivedate").attr("disabled", "disabled");
            //}
            //else {
            //    $(".toggleeffectivedate").removeAttr("disabled");
            //}


            if ($("#StatusEnrollmentCd option:selected").val() == inactiveStatus) {
                $(".inactivediv").attr("hidden", "hidden");
                //$(".toggleeffectivedate").removeAttr("disabled");
            }
        }

        //Determine the enrolment fees
        SetEnrolmentFees(enrolmentFees);

        //Determine the frequency options to set
        var ageGroupCategoryId = $("input[name='AgeGroupCd']:checked").val();
        var isSchoolAge = ageGroupCategoryId == $("#SchoolAgeCategoryId").val();

        if (isSchoolAge) {
            IsSchoolAge(true);
            $('.selectalldiv').attr("hidden", "hidden");
        }
        else {
            IsSchoolAge(false);
        }

        //toggle school age controls
        SetDailyFees(ageGroupCategoryId);

        var isPending = $("#IsLicensePending").val() == "True";

        if (isPending) {
            $("#ChngType-1").prop("disabled", true);
            $("#ChngType-2").prop("checked", true);

            $('.ChangeTypeRB').trigger("change");
        }
    });


    function SetDailyFeeTypeDiv() {
        var childAttendsDailyRV = $("input[name='AttendanceTypeCd']:checked").val();
        var ageGroupCategoryId = $("input[name='AgeGroupCd']:checked").val();
        var isSchoolAge = ageGroupCategoryId == $("#SchoolAgeCategoryId").val();
        var dailyFeeTypeRV = $("input[name='DailyFeeTypeCd']:checked").val();

        $(".selectalldiv").show();

        //Attends daily and not school age
        if (childAttendsDailyRV === '1' && !isSchoolAge) {
            $(".dailyfeetypediv").removeAttr("hidden");
            $("#DropinInfoDiv").attr("hidden", "hidden");

            if (typeof dailyFeeTypeRV !== 'undefined') {
                $('.basechildfeediv').removeAttr("hidden");
            }

            //Hide the attendance On old warning message
            $("#AttendanceTypeOnHoldMessage").attr("hidden", "hidden");
        }

        //Attends daily and is school age
        if (childAttendsDailyRV === '1' && isSchoolAge) {
            $(".dailyfeetypediv").attr("hidden", "hidden");
            $(".basechildfeediv").removeAttr("hidden");
            $("#DropinInfoDiv").attr("hidden", "hidden");

            $(".selectalldiv").hide();

            //Hide the attendance On old warning message
            $("#AttendanceTypeOnHoldMessage").attr("hidden", "hidden");
        }

        if (typeof childAttendsDailyRV === 'undefined') {
            //Hide the fees screen
            $(".dailyfeetypediv").attr("hidden", "hidden");

            //Hide the frequency screen
            $(".basechildfeediv").attr("hidden", "hidden");

            //DropinInfoDiv
            $("#DropinInfoDiv").attr("hidden", "hidden");

            //Hide the attendance On old warning message
            $("#AttendanceTypeOnHoldMessage").attr("hidden", "hidden");
        }

        //Drop-in 
        if (childAttendsDailyRV === '2') {
            //Hide the fees screen
            $(".dailyfeetypediv").attr("hidden", "hidden");

            //Hide the frequency screen
            $(".basechildfeediv").attr("hidden", "hidden");

            //DropinInfoDiv
            $("#DropinInfoDiv").removeAttr("hidden");

            //Unselect all the frequency grid
            $('.tick').each(function (index, obj) {
                this.checked = false;
            });

            //Unselect the select all checkbox
            document.getElementById("chkSelectAll").checked = false;

            //Hide the attendance On old warning message
            $("#AttendanceTypeOnHoldMessage").attr("hidden", "hidden");
        }

        //On hold
        if (childAttendsDailyRV === '3') {
            //Hide the fees screen
            $(".dailyfeetypediv").attr("hidden", "hidden");

            //Hide the frequency screen
            $(".basechildfeediv").attr("hidden", "hidden");

            //DropinInfoDiv
            $("#DropinInfoDiv").attr("hidden", "hidden");

            //Unselect all the frequency grid
            $('.tick').each(function (index, obj) {
                this.checked = false;
            });

            //Unselect the select all checkbox
            document.getElementById("chkSelectAll").checked = false;

            //Show the attendance On old warning message
            $("#AttendanceTypeOnHoldMessage").removeAttr("hidden");
        }

        ////If daily fee type is not selected then hide the frequency control
        //var childAttendsDailyRV = $("input[name='ChildAttendsDaily']:checked").val();
        //var dailyFeeTypeRV = $("input[name='DailyFeeTypeCd']:checked").val();
        //if (typeof dailyFeeTypeRV === 'undefined') {
        //    $(".basechildfeediv").attr("hidden", "hidden");
        //}
        //else {
        //    //Only display if the child attends daily RB is selected
        //    if (childAttendsDailyRV === "True") {
        //        $('.basechildfeediv').removeAttr("hidden");
        //    }
        //}

    }



    function SetReadOnlyMode() { 
        console.log('SetReadOnlyMode');
        $(".savecontrol").attr("hidden", "hidden");
        $(".saveandsend").attr("hidden", "hidden");

        $(".editcontrol").removeAttr("hidden");
        $(".togglecontrol").attr("disabled", "disabled");
        ShowHideInactiveRelatedGroups();
    }


    function SetEditOnlyMode() {
        $(".editcontrol").attr("hidden", "hidden");
        $(".savecontrol").removeAttr("hidden");
        $(".togglecontrol").removeAttr("disabled");

        if (StatusEnrollmentCd == 3 && EffectiveDate <= now)// @OpConst.EnumStatus.Inactive
        {
            $("#StatusEnrollmentCd").attr("disabled", "disabled");
            $("#ChngType-2").prop("checked", true);
        }

        //Check if this page reloaded due to an issue saving
        if (pageReload || (isAdmin && StatusEnrollmentCd == 3)) { // @OpConst.EnumStatus.Inactive
            //If this is a page reload then display all the edit controls
            $(".togglediv").removeAttr("hidden");
            $(".saveandsend").removeAttr("hidden");
            if (cannotModifyEffectiveDate) {
                $(".toggleeffectivedate").attr("disabled", "disabled");
            } else {
                $(".toggleeffectivedate").removeAttr("disabled");
            }
        }

        else {
            $(".togglediv").attr("hidden", "hidden");
            $(".saveandsend").attr("hidden", "hidden");
        }

        //if (EffectiveDate <= now) {
        //    $(".toggleeffectivedate").attr("disabled", "disabled");
        //}
        //else {
        //    $(".toggleeffectivedate").removeAttr("disabled");
        //}

        if ($("#StatusEnrollmentCd option:selected").val() == inactiveStatus) {
            $(".inactivediv").attr("hidden", "hidden");
            $(".toggleeffectivedate").removeAttr("disabled");
            $(".inactivedivlicence").attr("disabled", "disabled");
        }

         if (inactivemode) {
             $(".inactivediv").attr("hidden", "hidden");
             $(".inactivedivlicence").attr("disabled", "disabled");
        }

        if (inactivemode && EffectiveDate > now) {
            $('#textareainactive').val("");
        }

        if (inactivemode && EffectiveDate <= now) {
            $(".saveandsend").attr("hidden", "hidden");
            $(".toggleeffectivedate").attr("disabled", "disabled");
            $(".inactivedivreason").attr("disabled", "disabled");
        }
    }


    $("#btnEdit").on('click', function () {
        SetEditOnlyMode();
    });

    function SetSchoolAgeOptions() {
        $('.rad').each(function () {

            if ($(this).val() == $("#SchoolAgeCategoryId").val() && $(this).attr('checked') == 'checked') {
                //
                IsSchoolAge(true);
                return false;
            }
            else {
                IsSchoolAge(false);
            }
        });
    }

    $('.ChangeTypeRB').on('change', function () {

        //Display the rest of the edit form
        $(".togglediv").removeAttr("hidden").removeAttr("disabled");
        $(".saveandsend").removeAttr("hidden").removeAttr("disabled");


        if ($("#ChngType-1").is(":checked")) {
            $("#EffectiveDate").val("");
            $(".toggleeffectivedate").removeAttr("disabled");
        }
        else if ($("#ChngType-2").is(":checked")) {
            $("#EffectiveDate").val(EffectiveDate);

            //Enable/disable the effective date
            if (cannotModifyEffectiveDate) {
                $(".toggleeffectivedate").attr("disabled", "disabled");
            }
            else {
                $(".toggleeffectivedate").removeAttr("disabled");
            }
        }
    });

    $('#StatusEnrollmentCd').on('change', function () {

        //if inactive- clear or assign values
        if ($("#StatusEnrollmentCd option:selected").val() ==inactiveStatus ) {
        var fullDate = new Date()
        var twoDigitMonth = fullDate.getMonth() + 1 + "";
        if (twoDigitMonth.length == 1) twoDigitMonth = "0" + twoDigitMonth;
        var twoDigitDate = fullDate.getDate() + "";
        if (twoDigitDate.length == 1) twoDigitDate = "0" + twoDigitDate;
        var currentDate = fullDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate;
            inactivemode = true;

        $('#EndDate').val(currentDate);
            $(".inactivewarning").removeClass('d-none');
                $(".inactivediv").attr("hidden", "hidden");

    }
                else {

        $('#textareainactive').val("");
        $('#EndDate').val("");
            $(".inactivewarning").addClass('d-none');
            $(".inactivediv").removeAttr("hidden")
    }

    ShowHideInactiveRelatedGroups();

    HandleInactiveStatus(false);

            });

    function HandleSelectAll(obj) {
        if (obj.checked === true) {

            $('.tick').each(function (index, obj) {
                this.checked = true;
            });

        }
        else if (obj.checked === false) {

            $('.tick').each(function (index, obj) {
                this.checked = false;
            });

        };

        //Determine which fee input boxes to show
        HandleWeeklyFrequencyOptions();
    };

    function HandleFrequencyOptions(weekday) {

        //Only modify this for preschool
        if (!$('#Age-6').find('input[type="checkbox"]').is(':checked')) {
            if (typeof weekday !== 'undefined') {
                var totalChecked = 0;
                var weekdayclassname = '.' + weekday + 'tick';

                $(weekdayclassname).each(function (index, obj) {
                    if (this.checked === true) {

                        totalChecked += 1;
                    }
                });

                var chkweekday = '.chk' + weekday + 'fee';
                var lblweekday = '.lbl' + weekday + 'fee';

                if (totalChecked > 0) {
                    $(chkweekday).removeAttr("hidden");
                    $(lblweekday).attr("hidden", "hidden");
                }
                else {
                    $(chkweekday).attr("hidden", "hidden");
                    $(lblweekday).removeAttr("hidden");
                }

                //Calculate the max daily and part time fees
                UpdateEnrolmentFees();
            }
        }

        //toggle the the chkselectall control
        var sumTicked = 0;
        $('.tick').each(function (index, obj) {
            if (this.checked === true) {

                sumTicked += 1;
            }
        });
        if (sumTicked < 10) { document.getElementById("chkSelectAll").checked = false; }
        else { document.getElementById("chkSelectAll").checked = true; };

    };

    $(".rad").on('click', function () {

        if ($(this).val() == $("#SchoolAgeCategoryId").val())//6 means if Schoolage
        {
            IsSchoolAge(true);

            $('.selectalldiv').attr("hidden", "hidden");
        }
        else {
            IsSchoolAge(false);
            UpdateEnrolmentFees();

            $('.DailyFeeDiv').attr("hidden", "hidden");

        }

        //toggle school age controls
        SetDailyFees($(this).val());

    });

    function SubmitEnroll(status) {

        if ($("#EndDate").val() != null && $("#EndDate").val() != "") {
            if (status == "submit") {

                $("#btnSubmit").addClass("d-none");
                $("#btnYes").removeClass("d-none");
                $("#btnNo").removeClass("d-none");
                $("#msgConfirm").removeClass("d-none");
                return false;
            }
            else if (status == "yes") {
            }
            else if (status == "no") {
                $("#btnSubmit").removeClass("d-none");
                $("#btnYes").addClass("d-none");
                $("#btnNo").addClass("d-none");
            }
            $("#msgConfirm").addClass("d-none");

        }
    }

    if ($("#EffectiveDate").val() === "0001-01-01") {
        $("#EffectiveDate").val("");
    }

    $(".register-child-page").show();

    if ($("#EndDate").val() === "0001-01-01") {
        $("#EndDate").val("");
    }

    $(".register-child-page").show();

    $('#LicenseNumber').on('change', function () {
        // Louis: Hiding this for now. See ALM 3745
        //var url = licenseChangeUrl.replace('changeme', $(this).val());

        //// Return category select value
        //var categoryValue = $('select#LicenseNumber').val()

        //// If both selects have been changed, fetch results...
        //if (categoryValue) {
        //    // debug
        //    console.log('fetch results');
        //    // Result query
        //    $("#querydiv").load(url);
        //}

        //Update the enrolment fees
        UpdateEnrolmentFees();

        //Determine if the fee button should be displayed
        //ToggleBtnFee();

    });

    // Bind onchange to both selects
    //$(document).click(function (e) {
    //    var ele = $(e.toElement);
    //    if (!ele.hasClass("datepicker") && !ele.hasClass("input-group-append") && !ele.hasClass("input-group-text date") && !$(ele).parent().parents(".fa-calendar-alt").length)
    //        $(".datepicker").datetimepicker("hide");
    //});

    function ReloadDefaultValues() {

        SetSchoolAgeOptions();

        //Reset the old values
        $('select#LicenseNumber').val(LicensedFacility);

        $(AgeCategory).prop("checked", true);

        $('#MondayAM').prop('checked', MondayAM);
        $('#TuesdayAM').prop('checked', TuesdayAM);
        $('#WednesdayAM').prop('checked', WednesdayAM);
        $('#ThursdayAM').prop('checked', ThursdayAM);
        $('#FridayAM').prop('checked', FridayAM);

        $('#MondayPM').prop('checked', MondayPM);
        $('#TuesdayPM').prop('checked', TuesdayPM);
        $('#WednesdayPM').prop('checked', WednesdayPM);
        $('#ThursdayPM').prop('checked', ThursdayPM);
        $('#FridayPM').prop('checked', FridayPM);

        $('#MondayFull').prop('checked', MondayFull);
        $('#TuesdayFull').prop('checked', TuesdayFull);
        $('#WednesdayFull').prop('checked', WednesdayFull);
        $('#ThursdayFull').prop('checked', ThursdayFull);
        $('#FridayFull').prop('checked', FridayFull);
    }


    function HandleInactiveStatus(isOnload) {

        if ($("#StatusEnrollmentCd option:selected").val() ==inactiveStatus ) {

            ReloadDefaultValues();

            $('select#LicenseNumber').attr("disabled", "disabled");
            $('.rad').attr("disabled", "disabled");
            $('.tick').attr("disabled", "disabled");

            $('#chkSelectAll').attr("disabled", "disabled");
            $('#ExistingRegistration').attr("disabled", "disabled");

            //Only hide the buttons when the form first loads
            if (isOnload) {
                $('select#StatusEnrollmentCd').attr("disabled", "disabled");
                $('#textareainactive').attr("disabled", "disabled");
                $('#btnSubmit').attr("hidden", "hidden");
                $('#btnSubmitmodel').attr("hidden", "hidden");
                $('.datepicker').attr("disabled", "disabled");
            }
        }
        else {

            $('select#StatusEnrollmentCd').removeAttr("disabled");
            $('select#LicenseNumber').removeAttr("disabled");
            $('.rad').removeAttr("disabled");
            //$('#SchoolAgeCommentText').removeAttr("disabled");
            $('.tick').removeAttr("disabled");
            $('.datepicker').removeAttr("disabled");

            $('#textareainactive').removeAttr("disabled");
            $('#chkSelectAll').removeAttr("disabled");
            $('#ExistingRegistration').removeAttr("disabled");
        }
    }

    function ShowHideInactiveRelatedGroups() {
        if ($("#StatusEnrollmentCd option:selected").val() ==inactiveStatus )
        {

            $('.InactiveRelatedGroups').removeAttr("hidden");

        }
                else {

            $('.InactiveRelatedGroups').attr("hidden", "hidden");
        }

    }

    function HandleSubmitModal() {
        //
        if ($('#EndDate').val() != "" && $('#textareainactive').val() != "" && $("#StatusEnrollmentCd option:selected").val() == inactiveStatus)
        {
            $('#inactiveModal').modal('show');
        }
        else if ($('#EndDate').val() == "" && $('#textareainactive').val() == "" && $("#StatusEnrollmentCd option:selected").val() != inactiveStatus)
        {
            $(".frm").submit();
        } else {
            $(".frm").submit();
        }
    }

    $('#btnSubmit').on('click', function () { HandleSubmitModal(); });


    function UpdateEnrolmentFees() {

        //console.log(enrolmentFees);

        //Determine the enrolment fees
        SetEnrolmentFees(enrolmentFees);
    }

    function GetAgeGroup() {
        var category = $("input[name='AgeGroupCd']:checked").val();
        var ageGroup = '';

        //Determine the category value
        if (typeof category !== 'undefined') {
            category = '5000' + category;
        };

        return category;
    }

    function GetEffectiveDate() {

        if ($("#EffectiveDate").val() === "0001-01-01") {
            $("#EffectiveDate").val("");
        }

        var timestamp = '';
        var effectiveDate = new Date($("#EffectiveDate").val());

        // If the date object is invalid it
        // will return 'NaN' on getTime()
        // and NaN is never equal to itself.
        if (effectiveDate.getTime() === effectiveDate.getTime()) {
            //moment returns the number of milliseconds
            //so we need to divide by 1000 to convert to seconds
            timestamp = moment(effectiveDate, "YYYY/M/D").valueOf() / 1000;
        }
        return timestamp;
    }

    function SetEnrolmentFees(enrolmentFees) {
        var LicenseNumber = $('select#LicenseNumber').val();
        var AgeGroupType = GetAgeGroup();
        var EffectiveDate = GetEffectiveDate();

        //Only update enrolment fees for preschool enrolments
        if (!$('#Age-6').find('input[type="checkbox"]').is(':checked')) {
            //Determine the enrolment fees based on the license number, age group type and effective date
            var currentEnrolmentFees = GetEnrolmentFees(enrolmentFees, LicenseNumber, AgeGroupType, EffectiveDate);

            //console.log(currentEnrolmentFees);

            //Set the fees
            var FullDayFees = "----";
            var PartDayFees = "----";

            if (IsFullWeek()) {

                //Update the fees for Full Week
                if (currentEnrolmentFees.FullWeekFullDay > 0) {
                    FullDayFees = currentEnrolmentFees.FullWeekFullDayStr;
                }

                if (currentEnrolmentFees.FullWeekPartDay > 0) {
                    PartDayFees = currentEnrolmentFees.FullWeekPartDayStr;
                }
            }
            else {
                //Update the fees for Part Week
                if (currentEnrolmentFees.PartWeekFullDay > 0) {
                    FullDayFees = currentEnrolmentFees.PartWeekFullDayStr;
                }
                if (currentEnrolmentFees.PartWeekPartDay > 0) {
                    PartDayFees = currentEnrolmentFees.PartWeekPartDayStr;
                }
            }

            //Update the fees for Part Week
            $('#FullDayFees').text(FullDayFees);
            $('#PartDayFees').text(PartDayFees);
        }
    }

    function IsFullWeek() {
        var isFullWeek = isPartDay('monday') && isPartDay('tuesday') && isPartDay('wednesday') && isPartDay('thursday') && isPartDay('friday');
        return isFullWeek;
    }

    function isPartDay(weekday) {
        var totalChecked = 0;
        var weekdayclassname = '.' + weekday + 'tick';

        //Only modify this for preschool
        if (typeof weekday !== 'undefined') {

            $(weekdayclassname).each(function (index, obj) {
                if (this.checked === true) {
                    totalChecked += 1;
                }
            });
        }

        return totalChecked > 0;
    }

    function GetEnrolmentFees(enrolmentFees, LicenseNumber, AgeGroupType, EffectiveDate) {
        var currentTimestamp = 0;

        //Create an enrolment fee object with no fees
        var selectedEnrolmentFee = { "Id": -1, "LicenseNumber": LicenseNumber, "AlternateId": "", "EffectiveDate": EffectiveDate, "AgeGroupType": AgeGroupType, "FullWeekFullDay": 0.00, "FullWeekPartDay": 0.00, "PartWeekFullDay": 0.00, "PartWeekPartDay": 0.00, "FullWeekFullDayStr": "----", "FullWeekPartDayStr": "----", "PartWeekFullDayStr": "----", "PartWeekPartDayStr": "----" };

        //search based on License number, AgeGroupType
        enrolmentFees.forEach(function (item, index) {

            //Search for an enrollment fee for the given license and age group type
            if (item.LicenseNumber == LicenseNumber && item.AgeGroupType == AgeGroupType) {

                //Find the enrolment fee with the correct effective date
                if (item.EffectiveDate <= EffectiveDate && currentTimestamp < item.EffectiveDate) {
                    currentTimestamp = item.EffectiveDate;
                    selectedEnrolmentFee = item;
                }
            };
        });

        return selectedEnrolmentFee;
    }

    //function ToggleBtnFee(schoolAgeCategoryId) {
    //    var license = $('select#LicenseNumber').val();

    //    if (license != '' && !$('#Age-6').find('input[type="checkbox"]').is(':checked') && schoolAgeCategoryId != 6) {
    //        $('.btnfeediv').removeAttr("hidden");
    //    }
    //    else
    //    {
    //        $('.btnfeediv').attr("hidden", "hidden");
    //    }

    //}

    $('#DailyFeeStr').keyup(function () {
        var dailyFee = $('#DailyFeeStr').val();

        if (typeof dailyFee !== 'undefined') {
            dailyFee = dailyFee.replace(",", ".");
        }
        else {
            dailyFee = '----';
        }

        console.log(dailyFee);

        if ($.isNumeric(dailyFee)) {
            SetDailyFees();
        }
        else {
            $('.lblDailyFees').html('----');
        }
    });

    //when the focus leaves the text box change the formatting to 2 decimals
    $('#DailyFeeStr').blur(function () {
        var dailyFee = formatFeeValues();

        $('#DailyFeeStr').val(dailyFee);
    });

    function formatFeeValues() {

        var dailyFee = $('#DailyFeeStr').val();
        var formattedDailyFee = "----";

        if (typeof dailyFee !== 'undefined') {
            formattedDailyFee = dailyFee.replace(",", ".");
        };

        if ($.isNumeric(formattedDailyFee)) {
            
            var decimalPointLang = '.';
            if (lang == 'fr') {
                decimalPointLang = ',';
            }

            console.log(lang);

            //find the decimal location if it exists
            var decimalPointLocation = formattedDailyFee.lastIndexOf('.');
            var dailyFeeLength = formattedDailyFee.length;

            //Is there a decimal point?
            if (decimalPointLocation < 0) {
                dailyFee = dailyFee + decimalPointLang + '00';
            }
            else {
                //Are we missing a decimal value?
                if (decimalPointLocation == (dailyFeeLength - 1)) {
                    dailyFee = dailyFee + '00';
                }
                if (decimalPointLocation == (dailyFeeLength)) {
                    dailyFee = dailyFee + '00';
                }

                if (decimalPointLocation == (dailyFeeLength - 2)) {
                    dailyFee = dailyFee + '0';
                }

                if (decimalPointLocation <= (dailyFeeLength - 3)) {
                    dailyFee = dailyFee.substring(0, decimalPointLocation + 3);
                }
            }

            console.log(dailyFee);

            $('.lblDailyFees').html(dailyFee);
        }
        else {
            $('.lblDailyFees').html('----');
        }

        return dailyFee;
    }

    function SetDailyFees(ageCategory) {
        var radioValue = $("input[name='DailyFeeTypeCd']:checked").val();
        var dailyFee = $('#DailyFeeStr').val();

        console.log('SetDailyFees');

        if (typeof radioValue !== 'undefined') {


            if (radioValue == '1') {
                $('.nodailyfees').removeAttr("hidden"); /* Important that is done first */
                $('.feetooltip').attr("hidden", "hidden");
                $('.NotDailyFeeDiv').attr("hidden", "hidden");
                $('.DailyFeeDiv').removeAttr("hidden");
                $('.lblDailyFees').html(dailyFee);

                //Need to format the fees to add decimal places
                formatFeeValues();
            }

            if (radioValue == '2') {
                $('.nodailyfees').removeAttr("hidden"); /* Important that is done first */
                $('.NotDailyFeeDiv').removeAttr("hidden");
                $('.DailyFeeDiv').attr("hidden", "hidden");
                $('.NotDailyFeeDiv').removeAttr("hidden");
                $('.lblDailyFees').html('----');
            }

            if (radioValue == '3' || ageCategory == '6') {
                $('.feetooltip').attr("hidden", "hidden");
                $('.DailyFeeDiv').attr("hidden", "hidden");
                $('.nodailyfees').attr("hidden", "hidden");
                $('.feetooltip').attr("hidden", "hidden");
            }

            // School Age then display the checkbox
            if (ageCategory == '6') {
                $('.NotDailyFeeDiv').removeAttr("hidden");
            }
        }

        //Determine which divs to display
        SetDailyFeeTypeDiv();
    };


    //btnFee
    $("#btnFee").on('click', function () {

        var license = $('select#LicenseNumber').val();
        var alternateId = GetLicenseAlternateId(license);
        var highlightGroup = GetAgeGroup();
        var highlightFeeType = GetHighlightFee();
        var effectiveDate = $("#EffectiveDate").val();


        //license/home/fees/iwfl/bcror/?alternateId=bejhg
        var printURL = baseURL + '/' + lang + '/license/fees/index/' + oper + '/' + license + '/?alternateId=' + alternateId + '&highlightAgeGroupCd=' + highlightGroup + '&highlightFeeType=' + highlightFeeType + '&Date=' + effectiveDate;

        //console.log(license);
        //console.log(printURL);

        if (license != '') {
            window.open(printURL, "_blank");
        }
    });


    function GetLicenseAlternateId(license) {
        var AlternateId = '';

        licenses.forEach(function (item, index) {

            //Search for an enrollment fee for the given license and age group type
            if (item.licenseNumber === license) {
                AlternateId = item.alterateID;
                //console.log('altid:' + AlternateId);
                return AlternateId;
            };
        });

        return AlternateId;
    }

    function GetHighlightFee() {
        var highlightFee = '';

        if (IsFullWeek()) {
            highlightFee = '5';
        }
        else {
            highlightFee = '6';
        }

        return highlightFee;
    }


}